import { Route, Routes } from 'react-router-dom';

import MainLayout from 'src/Layouts/MainLayout';
import { NoFoundPage } from 'src/Pages';
import RequireAuth from 'src/Router/RequireAuth';
import { UnAuthorized } from 'src/Pages/UnAuthorized';
import { PublicRoutes, IPublicRoutes } from './PublicRoutes';
import { PrivateRoutes, IPrivateRoutes } from './PrivateRoutes';

const routes = () => {
  return (
    <Routes>
      <Route path="/" element={<MainLayout />}>
        {/* Public Routes */}
        {PublicRoutes?.map((route: IPublicRoutes, i: number) => (
          <Route {...route} path={route.path} element={route.element} key={i} />
        ))}
        <Route path="unauthorized" element={<UnAuthorized />} />
        {/* Private Routes */}
        <Route element={<RequireAuth allowedRoles={['is_staffer']} />}>
          {PrivateRoutes?.map((route: IPrivateRoutes, i: number) => (
            <Route
              {...route}
              path={route.path}
              element={route.element}
              key={i}
            />
          ))}
        </Route>
        {/* Catch All */}
        <Route path="*" element={<NoFoundPage />} />
      </Route>
    </Routes>
  );
};

export default routes;
